"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.darePlatformIcons = exports.darePlatformsMap = exports.providersIconMap = exports.platformsLabelMap = exports.providersLabelMap = void 0;
const faFacebook_1 = require("@fortawesome/free-brands-svg-icons/faFacebook");
const faGoogle_1 = require("@fortawesome/free-brands-svg-icons/faGoogle");
const faTiktok_1 = require("@fortawesome/free-brands-svg-icons/faTiktok");
const faTwitch_1 = require("@fortawesome/free-brands-svg-icons/faTwitch");
const faYoutube_1 = require("@fortawesome/free-brands-svg-icons/faYoutube");
const providers = {
    youtube: 'youtube',
    google: 'google',
    twitch: 'twitch',
    facebook: 'facebook',
    tiktok: 'tiktok',
    any: 'any',
};
exports.providersLabelMap = {
    [providers.twitch]: 'Twitch',
    [providers.youtube]: 'YouTube',
    [providers.google]: 'Google',
    [providers.facebook]: 'Facebook',
    [providers.tiktok]: 'TikTok',
};
exports.platformsLabelMap = {
    [providers.twitch]: 'Twitch',
    [providers.youtube]: 'YouTube',
    [providers.google]: 'Google',
    [providers.facebook]: 'Facebook',
    [providers.tiktok]: 'TikTok',
};
exports.providersIconMap = {
    [providers.twitch]: faTwitch_1.faTwitch,
    [providers.youtube]: faYoutube_1.faYoutube,
    [providers.google]: faGoogle_1.faGoogle,
    [providers.facebook]: faFacebook_1.faFacebook,
    [providers.tiktok]: faTiktok_1.faTiktok,
};
exports.darePlatformsMap = [
    providers.twitch,
    providers.youtube,
    providers.tiktok,
];
exports.darePlatformIcons = {
    [providers.twitch]: faTwitch_1.faTwitch,
    [providers.youtube]: faYoutube_1.faYoutube,
    [providers.tiktok]: faTiktok_1.faTiktok,
};
exports.default = providers;
